// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #ffffff;
  --white-100: #EFEFEF;
  --white-100-50: rgba(239, 239, 239, 0.5);
  --light-gray: rgba(130, 154, 181, 1);
  --white-1: rgba(255, 255, 255, 0.1);
  --white-02: rgba(255, 255, 255, 0.02);
  --white-4: rgba(255, 255, 255, 0.4);
  --white-5: rgba(255, 255, 255, 0.5);
  --white-08: rgba(255, 255, 255, 0.08);
  --black: #000000;
  --black-900: #050505;
  --textBlack: #393838;
  --black-35: rgb(0, 0, 0, 0.35);
  --btnText: rgb(111 60 0 / 81%);
  --darkText: #393838;
  --bgPrimary: #1C1C1C;
  --primaryBtn: #FFE500;
  --historyYellow: #453F02;
  --historyRed: #450A0A;
  --historyRedText: #F87171;
  --historyBlue: #172554;
  --historyBlueText: #60A5FA;
  --historyGreen: #022C22;
  --historyGreenText: #10B981;
  --historyGray: #222223;
  --historyGrayText: #A1A1AA;
  --GameModeBtnBorder: #2E323D;
  --PlaceBetBg: #6CF96C;
  --PlaceBetColor: #13151A;
  --wagerInputBg: #1f0a29;
  --wagerInputBorder: #6CF96C;
  --wagerInputBorder: #1A9A8F;
  --InputAddon: #155115;
  --TabBg: #0A0A0D;
  --TabBgActive: #252933;
  --modalBg: #0A0A0D;
  --Primary: #6CF96C;
  --WinLostModal: #75F975;
  --Error: #DC566B;
  --DarkGreen: linear-gradient(180deg, #13151A 0%, #155115 100%);
  --DarkRed: linear-gradient(180deg, #13151A 0%, #521814 100%);
  --Color-Red-600: #DC2626;
  --Mono-Primary-95: #0A0A0D;
  --Mono-Secondary-05: rgba(239, 239, 239, 0.50);
  --Mono-Primary-90: rgba(19, 21, 26, .7);
  --Mono-Primary-80: #252933;
  --Mono-Primary-98: #040405;
  --Game-Base-Green: #5DD55D;
  --kenoRed: #F23546;
  --kenoSelected: #6CF96C;
  --gameSidebarBg: linear-gradient(91.76deg, rgba(32, 30, 30, 1) 0%, rgba(32, 30, 30, 1) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.02) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);
  --gameInputBg: linear-gradient(91.76deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.35) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.06) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);
  --gameContainerOverlay: linear-gradient(91.76deg, rgba(32, 30, 30, 0.9) 0%, rgba(32, 30, 30, 0.75) 53.12%, rgba(32, 30, 30, 0.9) 100%);
  --gameNumbersSaperatorBg: linear-gradient(270deg, #FFE500 0%, rgba(254, 224, 64, 0.25) 100%);
  --gameKenoSlenderBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
  	linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0.95%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 100%);
  --gameKenoNumberCell: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
  	linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0.95%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.25) 100%);
  --gameKenoNumberGridBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
  	linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 30%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 70%, rgba(255, 255, 255, 0.20) 100%);
  --gameKenoNumberGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
  	linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);
  --gameKenoNumberGridSelectedBg: linear-gradient(36.57deg, #FFFFFF 54.8%, #FBE9CF 97.25%), linear-gradient(0deg, #FFFFFF, #FFFFFF);
  --kenoBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset, 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset;
  --kenoSelectedNumberShadow: 0px -4.182754039764404px 5.228443145751953px 0px #6C6C6C inset;
  box-shadow: 0px 4.1827540398px 4.1827540398px 0px rgba(0, 0, 0, 0.2509803922);
  --primary-300: #928403;
  --primary-600: #FFD600;
  --zinc-600: #52525B;
  --zinc-650: #4C4C52;
  --zinc-700: #252933;
  --zinc-800: #27272A;
  --zinc-850: #333333;
  --zinc-900: #18181B;
  --zinc-950: #09090B;
  --zinc-950-06: rgba(9, 9, 11, 0.6);
  --zinc-950-07: rgba(9, 9, 11, 0.7);
  --black: #000000;
  --black-20: rgba(0, 0, 0, 0.2);
  --black-30: rgb(0 0 0 / 30%);
  --gray-100-21: rgba(79, 79, 79, 0.21);
  --gray-200: #696969;
  --gray-300: #B8B8B8;
  --gray-400: #949494;
  --gray-700: #3D3D43;
  --gray-750: #272727;
  --gray-800: #212328;
  --gray-850-32: rgba(35, 35, 35, 0.32);
  --gray-850: #2A2A31;
  --gray-900: #191A1E;
  --gray-950: #232323;
  --gray-900-15: rgb(126 126 126 / 21%);
  --gray-975: #040404;
  --yellow-200-02: rgba(255, 230, 0, 0.2);
  --yellow-200-04: rgba(255, 230, 0, 0.4);
  --yellow-200-20: rgba(255, 229, 0, 0.20);
  --yellow-200-24: rgba(255, 230, 0, 0.24);
  --yellow-200-30: rgba(255, 229, 0, 0.30);
  --yellow-200-54: rgba(255, 230, 0, 0.54);
  --yellow-200-94: rgba(255, 230, 0, 0.94);
  --yellow-300-60: rgba(255, 230, 117, 0.60);
  --yellow-200-61: rgba(255, 222, 82, 0.61);
  --yellow-400: #F6D76B;
  --yellow-500: #F6C36B;
  --yellow-600: #FFE353;
  --yellow-700: #213621;
  --yellow-800: #EBC500;
  --yellow-900: #443D00;
  --pink-300: #FE6969;
  --pink-400: #E7635E;
  --pink-600: #E34A5C;
  --orange-300: #F0A265;
  --orange-350: #F39946;
  --orange-400: #F4754D;
  --orange-500: #FF5C00;
  --orange-900: rgba(244, 117, 77, 0.30);
  --orange-950-40: rgba(255, 229, 0, 0.40);
  --red-500: #EF4444;
  --red-600: #F80027;
  --red-900: #200000;
  --cyan-400: #7EFFF0;
  --cyan-900: #02312C;
  --purple-100-08: rgba(179, 19, 255, 0.08);
  --purple-100-30: rgba(179, 19, 255, 0.30);
  --purple-200: #0689FF;
  --purple-400: #8000FF;
  --purple-500: #B313FF;
  --purple-600-04: rgba(98, 1, 255, 0.4);
  --purple-600-24: rgba(98, 1, 255, 0.24);
  --purple-600-54: rgba(98, 1, 255, 0.54);
  --purple-600-94: rgba(98, 1, 255, 0.94);
  --purple-600-66: rgba(129, 59, 242, 0.66);
  --green-400: #6CF96C;
  --gameContainerBg: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);
  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);
  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),
  	radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);
  --orangeYellowRadialGradient: radial-gradient(61.67% 61.67% at 50% 50%, #FFE500 0%, #FF7A01 100%);
  --orangeYellowRadialGradientShadow: 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);
  --orangeYellowRadialGradientHover: radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);
  --orangeYellowRadialGradientHoverShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);
  --orangeYellowRadialGradientDisable: linear-gradient(0deg, rgba(170, 81, 0, 0.30) 0%, rgba(170, 81, 0, 0.30) 100%), radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);
  --orangeYellowRadialGradientDisableShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);
  --orangeYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.30) 0%, rgba(255, 229, 0, 0.30) 100%),
  	radial-gradient(68.33% 68.33% at 50% 50%, #FFE500 22.92%, #FF7A01 100%);
  --BgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);
  --SidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);
  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;
  --input-ps: 0.75rem;
  --input-pe: 0.75rem;
  --diamondBackground: #4F0473;
  --diamondBlockText: #FFE500;
  --greenGradient: #522A6B;
}

html,
body {
  height: 100%;
  overflow-x: hidden;
  background-color: var(--zinc-950);
}

*::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: var(--zinc-700);
  border-radius: 50em;
}
*::-webkit-scrollbar {
  width: 2px;
  background-color: var(--zinc-700);
  border-radius: 50em;
}
*::-webkit-scrollbar-thumb {
  border-radius: 50em;
  background-color: var(--gray-400);
}

body {
  color: var(--white);
  font-size: 0.938rem;
  font-family: "Saira", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  font-weight: 500;
}
body #root {
  height: 100%;
}
@media screen and (max-width: 767.98px) {
  body .Toastify .Toastify__toast-container {
    width: 50vw;
    left: auto;
    right: 0;
  }
  body .Toastify .Toastify__toast-container > div {
    min-height: 40px;
    gap: 0.5rem;
  }
  body .Toastify .Toastify__toast-container > div .Toastify__toast-body {
    line-height: 1.2;
    padding: 0;
  }
}
body .game-winning-overlay {
  background-color: rgba(19, 21, 26, 0.8);
}
body .game-winning-overlay .game-winning-popup {
  border: 2px solid #94EF5A;
  background: #1B1D29;
  border-radius: 1rem;
  color: #94EF5A;
  max-width: 11.625rem;
  min-height: 5.625rem;
}
@media screen and (max-width: 767.98px) {
  body .game-winning-overlay .game-winning-popup {
    max-width: 8.25rem;
    min-height: 4.625rem;
  }
}
body .game-winning-overlay .game-winning-popup .winning-multiplier-label {
  font-size: 1.875rem;
  font-weight: 600;
}
@media screen and (max-width: 767.98px) {
  body .game-winning-overlay .game-winning-popup .winning-multiplier-label {
    font-size: 1.25rem;
  }
}
body .game-winning-overlay .game-winning-popup .winning-popup-label-amt {
  background: #333744;
  min-height: 1.5625rem;
  min-width: 5.25rem;
  font-size: 0.75rem;
  font-weight: 600;
}
@media screen and (max-width: 767.98px) {
  body .game-winning-overlay .game-winning-popup .winning-popup-label-amt {
    min-width: 5rem;
  }
}
body .game-winning-overlay .game-lose-popup {
  border: 2px solid #ad2402;
  background: #1B1D29;
  border-radius: 1rem;
  color: #e9380b;
  max-width: 11.625rem;
  min-height: 5.625rem;
}
@media screen and (max-width: 767.98px) {
  body .game-winning-overlay .game-lose-popup {
    max-width: 8.25rem;
    min-height: 4.625rem;
  }
}
body .game-winning-overlay .game-lose-popup .winning-multiplier-label {
  font-size: 1.875rem;
  font-weight: 600;
}
@media screen and (max-width: 767.98px) {
  body .game-winning-overlay .game-lose-popup .winning-multiplier-label {
    font-size: 1.25rem;
  }
}
body .game-winning-overlay .game-lose-popup .winning-popup-label-amt {
  background: #333744;
  min-height: 1.5625rem;
  min-width: 5.25rem;
  font-size: 0.75rem;
  font-weight: 600;
}
@media screen and (max-width: 767.98px) {
  body .game-winning-overlay .game-lose-popup .winning-popup-label-amt {
    min-width: 5rem;
  }
}
body .container-fluid {
  max-width: 1613px;
}
@media screen and (max-width: 991.98px) {
  body:has(.keno-game-wrapper, .hilo-game-wrapper) .container-fluid {
    max-width: 500px;
    margin: 0 auto;
  }
}
body .nav-tabs {
  background-color: var(--TabBg);
  border-radius: 8px;
}
body .nav-tabs .nav-item .nav-link {
  color: var(--white-100-50);
  font-weight: 600;
  border-radius: 4px;
}
body .nav-tabs .nav-item .nav-link:hover {
  border-color: transparent;
}
body .nav-tabs .nav-item .nav-link.active {
  background-color: var(--TabBgActive);
  border: 1px solid var(--TabBgActive);
  color: var(--white-100);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab {
  color: var(--yellow-700);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab.active {
  background-color: var(--yellow-400);
  border-color: var(--yellow-400);
  color: var(--black);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab {
  color: var(--orange-400);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab.active {
  background-color: var(--orange-400);
  border-color: var(--orange-400);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab {
  color: var(--red-500);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab.active {
  background-color: var(--red-500);
  border-color: var(--red-500);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab {
  color: var(--cyan-400);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab.active {
  background-color: var(--cyan-400);
  border-color: var(--cyan-400);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-tab {
  background-color: var(--zinc-800);
  border-color: var(--zinc-800);
  color: var(--white);
  padding: 0.25rem 0.25rem;
  font-weight: 500;
  min-width: 48px;
  height: 36px;
  border-radius: 0.25rem;
}
body .btn-nav-tabs .strategy-btn-box .btn-outline-warning:hover,
body .btn-nav-tabs .strategy-btn-box .btn-outline-orange:hover,
body .btn-nav-tabs .strategy-btn-box .btn-outline-danger:hover {
  background-color: var(--zinc-800);
  border-color: var(--zinc-700);
  color: var(--white);
}
body select.form-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right var(--zinc-900);
  -webkit-appearance: none;
  background-position: calc(100% - 12px);
  background-size: 16px;
  padding-right: 35px !important;
}
body .form-control {
  min-height: 37px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: var(--input-ps);
  padding-right: var(--input-pe);
  background-color: var(--zinc-900);
  border-color: var(--zinc-900);
  color: var(--white);
}
body .form-control:focus {
  color: var(--white);
  background-color: var(--zinc-900);
  border-color: var(--zinc-700);
  box-shadow: none;
}
body .form-control:disabled {
  background-color: var(--zinc-900);
  opacity: 0.6;
  cursor: not-allowed;
}
body .custom-input-group .custom-input-group-text {
  gap: 0.375rem;
}
body .custom-input-group .custom-input-group-text .btn-input-addon {
  border: 1px solid var(--zinc-800);
  background-color: #383E4D !important;
  color: #090909 !important;
  border-radius: 0.25rem;
  height: 28px;
  padding: 0.125px 0.425rem;
  font-weight: 500;
  font-size: 10px;
}
body .custom-input-group .custom-input-group-text .btn-input-addon:is(:active, :hover):enabled {
  background-color: var(--zinc-700);
  border: 1px solid var(--zinc-700);
}
body .custom-input-group .custom-input-group-text .input-form-control {
  min-height: 30px !important;
  height: 30px !important;
}
body .border-transparent {
  border-color: transparent !important;
}
body .text-gray-400 {
  color: var(--gray-400);
}
body .btn-place-bet {
  font-size: 1rem;
  font-weight: 600;
  min-height: 40px;
}
body button:disabled {
  cursor: not-allowed;
  pointer-events: all;
  opacity: 0.6;
}
body .pointer-events-none {
  pointer-events: none;
}
@media (min-width: 992px) {
  body .g-lg-40,
  body .gx-lg-40 {
    --bs-gutter-x: 2.5rem;
  }
  body .mb-lg-20 {
    margin-bottom: 1.25rem !important;
  }
}

@keyframes smooth-slide {
  0% {
    transform: scale(0) translateY(-100%);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes smooth-slide1 {
  0% {
    transform: translateY(-100%);
  }
}
@keyframes smooth-slide2 {
  0% {
    transform: scale(1) translateY(-100%);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes smooth-slide-x {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes smooth-slide-x1 {
  0% {
    transform: translateX(-100%);
  }
}
@keyframes smooth-slide-x2 {
  0% {
    transform: translateX(-100%);
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  transform: scale(0.9);
}

select option {
  color: var(--white);
  background: var(--bgPrimary);
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  box-shadow: none;
  border-color: red !important;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: none;
}

.gradient-btn, .gradient-btn-full {
  background: #522A6B !important;
  color: #EFEFEF !important;
  border: 0 !important;
  height: 41px !important;
  min-height: 41px !important;
  border-radius: 8px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 21px !important;
  box-shadow: 0px 0px 10px 0px rgba(195, 101, 250, 0.4), 0px -3px 0px 0px rgba(0, 0, 0, 0.1490196078) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.2) inset;
}
.gradient-btn:hover, .gradient-btn-full:hover {
  background: #663883 !important;
}

.gradient-btn-full {
  width: 100% !important;
}

.items-center {
  align-items: center;
}

.font-semibold {
  font-weight: 600;
}

.conic-gradient-text, .conic-gradient-text-md, .conic-gradient-text-sm {
  background: #522A6B;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  color: transparent !important;
  line-height: 18px !important;
}

.conic-gradient-text-sm {
  font-size: 14px !important;
  font-weight: 400 !important;
}

.conic-gradient-text-md {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_variables.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EAEC,gBAAA;EACA,oBAAA;EACA,wCAAA;EACA,oCAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,8DAAA;EACA,4DAAA;EACA,wBAAA;EACA,0BAAA;EACA,8CAAA;EACA,uCAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EAGA,6NAAA;EACA,2QAAA;EACA,sIAAA;EACA,4FAAA;EAEA;yHAAA;EAGA;yHAAA;EAGA;oLAAA;EAGA;6GAAA;EAGA,iIAAA;EAEA,mLAAA;EAEA,0FAAA;EACA,6EAAA;EAKA,sBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kCAAA;EAEA,gBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EAGA,uCAAA;EACA,uCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,0CAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,wCAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,yCAAA;EACA,oBAAA;EAEA,wGAAA;EAEA,iGAAA;EACA,0GAAA;EACA;0EAAA;EAGA,iGAAA;EACA,8EAAA;EACA,sGAAA;EACA,4GAAA;EACA,uLAAA;EACA,8GAAA;EACA;0EAAA;EAGA,iKAAA;EACA,kIAAA;EAEA,oGAAA;EAEA,mBAAA;EACA,mBAAA;EAGA,4BAAA;EACA,2BAAA;EAEA,wBAAA;AChCD;;AAzJA;;EAEE,YAAA;EACA,kBAAA;EACA,iCAAA;AA4JF;;AAzJE;EACE,oDAAA;EACA,iCAAA;EACA,mBAAA;AA4JJ;AAzJE;EACE,UAAA;EACA,iCAAA;EACA,mBAAA;AA2JJ;AAxJE;EACE,mBAAA;EACA,iCAAA;AA0JJ;;AAvJA;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;AAyJF;AAvJE;EACE,YAAA;AAyJJ;AApJG;EADD;IAEE,WAAA;IACA,UAAA;IACA,QAAA;EAuJF;EArJE;IACC,gBAAA;IACK,WAAA;EAuJR;EArJG;IACC,gBAAA;IACA,UAAA;EAuJJ;AACF;AAjJC;EACC,uCAAA;AAmJF;AAjJE;EACC,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;AAmJH;AAjJG;EARD;IASE,kBAAA;IACA,oBAAA;EAoJF;AACF;AAlJG;EACC,mBAAA;EACA,gBAAA;AAoJJ;AAlJI;EAJD;IAKE,kBAAA;EAqJH;AACF;AAlJG;EACC,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAoJJ;AAlJI;EAPD;IAQE,eAAA;EAqJH;AACF;AAjJI;EACD,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;AAmJH;AAjJG;EARC;IASA,kBAAA;IACA,oBAAA;EAoJF;AACF;AAlJG;EACC,mBAAA;EACA,gBAAA;AAoJJ;AAlJI;EAJD;IAKE,kBAAA;EAqJH;AACF;AAlJG;EACC,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAoJJ;AAlJI;EAPD;IAQE,eAAA;EAqJH;AACF;AAhJE;EACE,iBAAA;AAkJJ;AA7IG;EADD;IAEE,gBAAA;IACA,cAAA;EAgJF;AACF;AA5IE;EACE,8BAAA;EACA,kBAAA;AA8IJ;AA3IM;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;AA6IR;AA3IQ;EACE,yBAAA;AA6IV;AA1IQ;EACE,oCAAA;EACA,oCAAA;EACA,uBAAA;AA4IV;AArII;EACE,wBAAA;AAuIN;AArIM;EAEE,mCAAA;EACA,+BAAA;EACA,mBAAA;AAsIR;AAlII;EACE,wBAAA;AAoIN;AAlIM;EAEE,mCAAA;EACA,+BAAA;EACA,sBAAA;AAmIR;AA/HI;EACE,qBAAA;AAiIN;AA/HM;EAEE,gCAAA;EACA,4BAAA;EACA,sBAAA;AAgIR;AA5HI;EACE,sBAAA;AA8HN;AA5HM;EAEE,iCAAA;EACA,6BAAA;EACA,sBAAA;AA6HR;AAzHI;EACE,iCAAA;EACA,6BAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AA2HN;AAlHM;;;EAGE,iCAAA;EACA,6BAAA;EACA,mBAAA;AAoHR;AA9GI;EACE,mFAAA;EAEA,wBAAA;EACA,sCAAA;EACA,qBAAA;EACA,8BAAA;AA+GN;AA3GE;EACE,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,mBAAA;AA6GJ;AA3GI;EACE,mBAAA;EACA,iCAAA;EACA,6BAAA;EACA,gBAAA;AA6GN;AA1GI;EACE,iCAAA;EACA,YAAA;EACA,mBAAA;AA4GN;AAvGI;EACE,aAAA;AAyGN;AAvGM;EACF,iCAAA;EACI,oCAAA;EACJ,yBAAA;EACI,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAyGR;AAvGQ;EACE,iCAAA;EACA,iCAAA;AAyGV;AArGM;EACE,2BAAA;EACA,uBAAA;AAuGR;AAlGE;EACE,oCAAA;AAoGJ;AAjGE;EACE,sBAAA;AAmGJ;AAhGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAkGJ;AA9FI;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAgGN;AA7FE;EACE,oBAAA;AA+FJ;AA5FE;EACE;;IAEE,qBAAA;EA8FJ;EA3FE;IACE,iCAAA;EA6FJ;AACF;;AAzFA;EACE;IACE,qCAAA;EA4FF;EAzFA;IACE,mBAAA;EA2FF;AACF;AAxFA;EACE;IACE,4BAAA;EA0FF;AACF;AAvFA;EACE;IACE,qCAAA;EAyFF;EAtFA;IACE,mBAAA;EAwFF;AACF;AArFA;EACE;IACE,mBAAA;EAuFF;EApFA;IACE,mBAAA;EAsFF;AACF;AAnFA;EACE;IACE,4BAAA;EAqFF;AACF;AAlFA;EACE;IACE,4BAAA;EAoFF;AACF;AAjFA,gCAAA;AACA;;EAEE,qBAAA;AAmFF;;AA1EA;EACE,mBAAA;EACA,4BAAA;AA6EF;;AA1EA;;EAEE,gBAAA;EACA,4BAAA;AA6EF;;AA1EA;;EAEE,sBAAA;AA6EF;;AA1EA;EACE,8BAAA;EACA,yBAAA;EACA,oBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACD,yJAAA;AA6ED;AA1EC;EACC,8BAAA;AA4EF;;AAxEA;EAEE,sBAAA;AA0EF;;AAvEA;EACE,mBAAA;AA0EF;;AAvEA;EACE,gBAAA;AA0EF;;AAvEA;EACE,mBAAA;EACA,wCAAA;EACA,gCAAA;EACA,6BAAA;EACA,4BAAA;AA0EF;;AAvEA;EAEE,0BAAA;EACA,2BAAA;AAyEF;;AAtEA;EAEE,0BAAA;EACA,2BAAA;EACA,YAAA;AAwEF","sourcesContent":[":root {\n\t// colors variables\n\t--white: #ffffff;\n\t--white-100: #EFEFEF;\n\t--white-100-50: rgba(239, 239, 239, 0.5);\n\t--light-gray: rgba(130, 154, 181, 1);\n\t--white-1: rgba(255, 255, 255, 0.1);\n\t--white-02: rgba(255, 255, 255, 0.02);\n\t--white-4: rgba(255, 255, 255, 0.4);\n\t--white-5: rgba(255, 255, 255, 0.5);\n\t--white-08: rgba(255, 255, 255, 0.08);\n\t--black: #000000;\n\t--black-900: #050505;\n\t--textBlack: #393838;\n\t--black-35: rgb(0, 0, 0, 0.35);\n\t--btnText: rgb(111 60 0 / 81%);\n\t--darkText: #393838;\n\t--bgPrimary: #1C1C1C;\n\t--primaryBtn: #FFE500;\n\t--historyYellow: #453F02;\n\t--historyRed: #450A0A;\n\t--historyRedText: #F87171;\n\t--historyBlue: #172554;\n\t--historyBlueText: #60A5FA;\n\t--historyGreen: #022C22;\n\t--historyGreenText: #10B981;\n\t--historyGray: #222223;\n\t--historyGrayText: #A1A1AA;\n\t--GameModeBtnBorder: #2E323D;\n\t--PlaceBetBg: #6CF96C;\n\t--PlaceBetColor: #13151A;\n\t--wagerInputBg: #1f0a29;\n\t--wagerInputBorder: #6CF96C;\n\t--wagerInputBorder: #1A9A8F;\n\t--InputAddon: #155115;\n\t--TabBg: #0A0A0D;\n\t--TabBgActive: #252933;\n\t--modalBg: #0A0A0D;\n\t--Primary: #6CF96C;\n\t--WinLostModal: #75F975;\n\t--Error: #DC566B;\n\t--DarkGreen: linear-gradient(180deg, #13151A 0%, #155115 100%);\n\t--DarkRed: linear-gradient(180deg, #13151A 0%, #521814 100%);\n\t--Color-Red-600: #DC2626;\n\t--Mono-Primary-95: #0A0A0D;\n\t--Mono-Secondary-05: rgba(239, 239, 239, 0.50);\n\t--Mono-Primary-90: rgba(19, 21, 26, .7);\n\t--Mono-Primary-80: #252933;\n\t--Mono-Primary-98: #040405;\n\t--Game-Base-Green: #5DD55D;\n\t--kenoRed: #F23546;\n\t--kenoSelected: #6CF96C;\n\n\t// gradient variables\n\t--gameSidebarBg: linear-gradient(91.76deg, rgba(32, 30, 30, 1) 0%, rgba(32, 30, 30, 1) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.02) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);\n\t--gameInputBg: linear-gradient(91.76deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.35) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.06) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);\n\t--gameContainerOverlay: linear-gradient(91.76deg, rgba(32, 30, 30, 0.9) 0%, rgba(32, 30, 30, 0.75) 53.12%, rgba(32, 30, 30, 0.9) 100%);\n\t--gameNumbersSaperatorBg: linear-gradient(270deg, #FFE500 0%, rgba(254, 224, 64, 0.25) 100%);\n\n\t--gameKenoSlenderBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n\t\tlinear-gradient(90deg, rgba(255, 255, 255, 0.20) 0.95%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 100%);\n\n\t--gameKenoNumberCell: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n\t\tlinear-gradient(90deg, rgba(255, 255, 255, 0.25) 0.95%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.25) 100%);\n\n\t--gameKenoNumberGridBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n\t\tlinear-gradient(90deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 30%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 70%, rgba(255, 255, 255, 0.20) 100%);\n\n\t--gameKenoNumberGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n\t\tlinear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);\n\n\t--gameKenoNumberGridSelectedBg: linear-gradient(36.57deg, #FFFFFF 54.8%, #FBE9CF 97.25%), linear-gradient(0deg, #FFFFFF, #FFFFFF);\n\n\t--kenoBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset, 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset;\n\n\t--kenoSelectedNumberShadow: 0px -4.182754039764404px 5.228443145751953px 0px #6C6C6C inset;\n\tbox-shadow: 0px 4.182754039764404px 4.182754039764404px 0px #00000040;\n\n\n\t// new variable\n\n\t--primary-300: #928403;\n\t--primary-600: #FFD600;\n\n\t--zinc-600: #52525B;\n\t--zinc-650: #4C4C52;\n\t--zinc-700: #252933;\n\t--zinc-800: #27272A;\n\t--zinc-850: #333333;\n\t--zinc-900: #18181B;\n\t--zinc-950: #09090B;\n\t--zinc-950-06: rgba(9, 9, 11, 0.6);\n\t--zinc-950-07: rgba(9, 9, 11, 0.7);\n\n\t--black: #000000;\n\t--black-20: rgba(0, 0, 0, 0.2);\n\t--black-30: rgb(0 0 0 / 30%);\n\n\t--gray-100-21: rgba(79, 79, 79, 0.21);\n\t--gray-200: #696969;\n\t--gray-300: #B8B8B8;\n\t--gray-400: #949494;\n\t--gray-700: #3D3D43;\n\t--gray-750: #272727;\n\t--gray-800: #212328;\n\t--gray-850-32: rgba(35, 35, 35, 0.32);\n\t--gray-850: #2A2A31;\n\t--gray-900: #191A1E;\n\t--gray-950: #232323;\n\t--gray-900-15: rgb(126 126 126 / 21%);\n\t--gray-975: #040404;\n\n\t// history colors variables\n\t--yellow-200-02: rgba(255, 230, 0, 0.2);\n\t--yellow-200-04: rgba(255, 230, 0, 0.4);\n\t--yellow-200-20: rgba(255, 229, 0, 0.20);\n\t--yellow-200-24: rgba(255, 230, 0, 0.24);\n\t--yellow-200-30: rgba(255, 229, 0, 0.30);\n\t--yellow-200-54: rgba(255, 230, 0, 0.54);\n\t--yellow-200-94: rgba(255, 230, 0, 0.94);\n\t--yellow-300-60: rgba(255, 230, 117, 0.60);\n\t--yellow-200-61: rgba(255, 222, 82, 0.61);\n\t--yellow-400: #F6D76B;\n\t--yellow-500: #F6C36B;\n\t--yellow-600: #FFE353;\n\t--yellow-700: #213621;\n\t--yellow-800: #EBC500;\n\t--yellow-900: #443D00;\n\n\t--pink-300: #FE6969;\n\t--pink-400: #E7635E;\n\t--pink-600: #E34A5C;\n\n\t--orange-300: #F0A265;\n\t--orange-350: #F39946;\n\t--orange-400: #F4754D;\n\t--orange-500: #FF5C00;\n\t--orange-900: rgba(244, 117, 77, 0.30);\n\t--orange-950-40: rgba(255, 229, 0, 0.40);\n\n\t--red-500: #EF4444;\n\t--red-600: #F80027;\n\t--red-900: #200000;\n\n\t--cyan-400: #7EFFF0;\n\t--cyan-900: #02312C;\n\n\t--purple-100-08: rgba(179, 19, 255, 0.08);\n\t--purple-100-30: rgba(179, 19, 255, 0.30);\n\t--purple-200: #0689FF;\n\t--purple-400: #8000FF;\n\t--purple-500: #B313FF;\n\t--purple-600-04: rgba(98, 1, 255, 0.4);\n\t--purple-600-24: rgba(98, 1, 255, 0.24);\n\t--purple-600-54: rgba(98, 1, 255, 0.54);\n\t--purple-600-94: rgba(98, 1, 255, 0.94);\n\t--purple-600-66: rgba(129, 59, 242, 0.66);\n\t--green-400: #6CF96C;\n\n\t--gameContainerBg: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);\n\n\t--purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);\n\t--purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);\n\t--purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),\n\t\tradial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);\n\t\n\t--orangeYellowRadialGradient: radial-gradient(61.67% 61.67% at 50% 50%, #FFE500 0%, #FF7A01 100%);\n\t--orangeYellowRadialGradientShadow: 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);\n\t--orangeYellowRadialGradientHover: radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);\n\t--orangeYellowRadialGradientHoverShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);\n\t--orangeYellowRadialGradientDisable: linear-gradient(0deg, rgba(170, 81, 0, 0.30) 0%, rgba(170, 81, 0, 0.30) 100%), radial-gradient(61.67% 61.67% at 50% 50%, #FFFF46 0%, #F58E15 100%);\n\t--orangeYellowRadialGradientDisableShadow: 0px 4px 0px 0px #AA5100, 0px 1px 12.2px 3px rgba(255, 229, 0, 0.40);\n\t--orangeYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.30) 0%, rgba(255, 229, 0, 0.30) 100%),\n\t\tradial-gradient(68.33% 68.33% at 50% 50%, #FFE500 22.92%, #FF7A01 100%);\n\n\t--BgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);\n\t--SidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);\n\n\t--primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;\n\n\t--input-ps: 0.75rem;\n\t--input-pe: 0.75rem;\n\n\t//keno-game\n\t--diamondBackground: #4F0473;\n\t--diamondBlockText: #FFE500;\n\n\t--greenGradient: #522A6B;\n}\n","@import \"./assets/scss/variables\";\n\nhtml,\nbody {\n  height: 100%;\n  overflow-x: hidden;\n  background-color: var(--zinc-950);\n}\n* {\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: var(--zinc-700);\n    border-radius: 50em;\n  }\n\n  &::-webkit-scrollbar {\n    width: 2px;\n    background-color: var(--zinc-700);\n    border-radius: 50em;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 50em;\n    background-color: var(--gray-400);\n  }\n}\nbody {\n  color: var(--white);\n  font-size: 0.938rem;\n  font-family: \"Saira\", sans-serif;\n  font-optical-sizing: auto;\n  font-style: normal;\n\n  font-weight: 500;\n\n  #root {\n    height: 100%;\n  }\n\n\t.Toastify {\n\t\t.Toastify__toast-container {\n\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\twidth: 50vw;\n\t\t\t\tleft: auto;\n\t\t\t\tright: 0;\n\n\t\t\t\t&>div {\n\t\t\t\t\tmin-height: 40px;\n          gap: 0.5rem;\n\n\t\t\t\t\t.Toastify__toast-body {\n\t\t\t\t\t\tline-height: 1.2;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.game-winning-overlay {\n\t\tbackground-color: rgba(19, 21, 26, 0.8);\n\n\t\t.game-winning-popup {\n\t\t\tborder: 2px solid #94EF5A;\n\t\t\tbackground: #1B1D29;\n\t\t\tborder-radius: 1rem;\n\t\t\tcolor: #94EF5A;\n\t\t\tmax-width: 11.625rem;\n\t\t\tmin-height: 5.625rem;\n\n\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\tmax-width: 8.25rem;\n\t\t\t\tmin-height: 4.625rem;\n\t\t\t}\n\n\t\t\t.winning-multiplier-label {\n\t\t\t\tfont-size: 1.875rem;\n\t\t\t\tfont-weight: 600;\n\n\t\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.winning-popup-label-amt {\n\t\t\t\tbackground: #333744;\n\t\t\t\tmin-height: 1.5625rem;\n\t\t\t\tmin-width: 5.25rem;\n\t\t\t\tfont-size: .75rem;\n\t\t\t\tfont-weight: 600;\n\n\t\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\t\tmin-width: 5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n    .game-lose-popup {\n\t\t\tborder: 2px solid #ad2402;\n\t\t\tbackground: #1B1D29;\n\t\t\tborder-radius: 1rem;\n\t\t\tcolor: #e9380b;\n\t\t\tmax-width: 11.625rem;\n\t\t\tmin-height: 5.625rem;\n\n\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\tmax-width: 8.25rem;\n\t\t\t\tmin-height: 4.625rem;\n\t\t\t}\n\n\t\t\t.winning-multiplier-label {\n\t\t\t\tfont-size: 1.875rem;\n\t\t\t\tfont-weight: 600;\n\n\t\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.winning-popup-label-amt {\n\t\t\t\tbackground: #333744;\n\t\t\t\tmin-height: 1.5625rem;\n\t\t\t\tmin-width: 5.25rem;\n\t\t\t\tfont-size: .75rem;\n\t\t\t\tfont-weight: 600;\n\n\t\t\t\t@media screen and (max-width: 767.98px) {\n\t\t\t\t\tmin-width: 5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n  .container-fluid {\n    max-width: 1613px;\n  }\n\n\t&:has(.keno-game-wrapper, .hilo-game-wrapper) {\n\t\t.container-fluid {\n\t\t\t@media screen and (max-width: 991.98px) {\n\t\t\t\tmax-width: 500px;\n\t\t\t\tmargin: 0 auto;\n\t\t\t}\n\t\t}\n\t}\n\n  .nav-tabs {\n    background-color: var(--TabBg);\n    border-radius: 8px;\n\n    .nav-item {\n      .nav-link {\n        color: var(--white-100-50);\n        font-weight: 600;\n        border-radius: 4px;\n\n        &:hover {\n          border-color: transparent;\n        }\n\n        &.active {\n          background-color: var(--TabBgActive);\n          border: 1px solid var(--TabBgActive);\n          color: var(--white-100);\n        }\n      }\n    }\n  }\n\n  .btn-nav-tabs {\n    .btn-nav-tab-items:nth-child(1) .btn-tab {\n      color: var(--yellow-700);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--yellow-400);\n        border-color: var(--yellow-400);\n        color: var(--black);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(2) .btn-tab {\n      color: var(--orange-400);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--orange-400);\n        border-color: var(--orange-400);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(3) .btn-tab {\n      color: var(--red-500);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--red-500);\n        border-color: var(--red-500);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(4) .btn-tab {\n      color: var(--cyan-400);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--cyan-400);\n        border-color: var(--cyan-400);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-tab {\n      background-color: var(--zinc-800);\n      border-color: var(--zinc-800);\n      color: var(--white);\n      padding: 0.25rem 0.25rem;\n      font-weight: 500;\n      min-width: 48px;\n      height: 36px;\n      border-radius: 0.25rem;\n      // &.active {\n      //   background-color: var(--orange-400);\n      //   border-color: var(--orange-400);\n      //   color: var(--zinc-950) !important;\n      // }\n    }\n\n    .strategy-btn-box {\n      .btn-outline-warning:hover,\n      .btn-outline-orange:hover,\n      .btn-outline-danger:hover {\n        background-color: var(--zinc-800);\n        border-color: var(--zinc-700);\n        color: var(--white);\n      }\n    }\n  }\n\n  select {\n    &.form-control {\n      background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\")\n        no-repeat right var(--zinc-900);\n      -webkit-appearance: none;\n      background-position: calc(100% - 12px);\n      background-size: 16px;\n      padding-right: 35px !important;\n    }\n  }\n\n  .form-control {\n    min-height: 37px;\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    padding-left: var(--input-ps);\n    padding-right: var(--input-pe);\n    background-color: var(--zinc-900);\n    border-color: var(--zinc-900);\n    color: var(--white);\n\n    &:focus {\n      color: var(--white);\n      background-color: var(--zinc-900);\n      border-color: var(--zinc-700);\n      box-shadow: none;\n    }\n\n    &:disabled {\n      background-color: var(--zinc-900);\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  .custom-input-group {\n    .custom-input-group-text {\n      gap: 0.375rem;\n\n      .btn-input-addon {\n\t\t\t\tborder: 1px solid var(--zinc-800);\n        background-color: #383E4D !important;\n\t\t\t\tcolor: #090909 !important;\n        border-radius: 0.25rem;\n        height: 28px;\n        padding: 0.125px 0.425rem;\n        font-weight: 500;\n        font-size: 10px;\n\n        &:is(:active, :hover):enabled {\n          background-color: var(--zinc-700);\n          border: 1px solid var(--zinc-700);\n        }\n      }\n\n      .input-form-control {\n        min-height: 30px !important;\n        height: 30px !important;\n      }\n    }\n  }\n\n  .border-transparent {\n    border-color: transparent !important;\n  }\n\n  .text-gray-400 {\n    color: var(--gray-400);\n  }\n\n  .btn-place-bet {\n    font-size: 1rem;\n    font-weight: 600;\n    min-height: 40px;\n  }\n\n  button {\n    &:disabled {\n      cursor: not-allowed;\n      pointer-events: all;\n      opacity: 0.6;\n    }\n  }\n  .pointer-events-none {\n    pointer-events: none;\n  }\n\n  @media (min-width: 992px) {\n    .g-lg-40,\n    .gx-lg-40 {\n      --bs-gutter-x: 2.5rem;\n    }\n\n    .mb-lg-20 {\n      margin-bottom: 1.25rem !important;\n    }\n  }\n}\n\n@keyframes smooth-slide {\n  0% {\n    transform: scale(0) translateY(-100%);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes smooth-slide1 {\n  0% {\n    transform: translateY(-100%);\n  }\n}\n\n@keyframes smooth-slide2 {\n  0% {\n    transform: scale(1) translateY(-100%);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes smooth-slide-x {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes smooth-slide-x1 {\n  0% {\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes smooth-slide-x2 {\n  0% {\n    transform: translateX(-100%);\n  }\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  transform: scale(0.9);\n}\n\n// /* Firefox */\n// input[type=number] {\n//   appearance: textfield;\n//   -moz-appearance: textfield;\n// }\n\nselect option {\n  color: var(--white);\n  background: var(--bgPrimary);\n}\n\n.form-control.is-invalid:focus,\n.was-validated .form-control:invalid:focus {\n  box-shadow: none;\n  border-color: red !important;\n}\n\n.form-control.is-invalid,\n.was-validated .form-control:invalid {\n  background-image: none;\n}\n\n.gradient-btn {\n  background: #522A6B !important;\n  color: #EFEFEF !important;\n  border: 0 !important;\n  height: 41px !important;\n  min-height: 41px !important;\n  border-radius: 8px !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  line-height: 21px !important;\n\tbox-shadow: 0px 0px 10px 0px #C365FA66, 0px -3px 0px 0px #00000026 inset, 0px 1px 0px 0px #FFFFFF33 inset;\n\n\n\t&:hover {\n\t\tbackground: #663883 !important;\n\t}\n}\n\n.gradient-btn-full {\n  @extend .gradient-btn;\n  width: 100% !important;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.conic-gradient-text {\n  background: #522A6B;\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n  color: transparent !important;\n  line-height: 18px !important;\n}\n\n.conic-gradient-text-sm {\n  @extend .conic-gradient-text;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\n.conic-gradient-text-md {\n  @extend .conic-gradient-text;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
